import { createContext, useContext, useState, useCallback, PropsWithChildren, useRef } from 'react';

import { registerSW } from 'virtual:pwa-register';

// Create context
const UpdateServiceWorkerContext = createContext({
    isUpdateAvailable: false, // No update available by default
    triggerUpdate: () => {
      console.warn('triggerUpdate called without a provider.'); 
    },
  });

// Custom hook for accessing context
export const useUpdateServiceWorker = () => useContext(UpdateServiceWorkerContext);

// Provider component
export const UpdateServiceWorkerProvider = ({ children }: PropsWithChildren) => {
  const [isUpdateAvailable, setIsUpdateAvailable] = useState(false);
  
  // Store the update function in a ref instead of state
  const updateFnRef = useRef(registerSW({
    onNeedRefresh() {
      setIsUpdateAvailable(true);
    }
  }));

  const triggerUpdate = useCallback(() => {
    updateFnRef.current(true);
    setIsUpdateAvailable(false);
  }, []); // No need for dependency since we're using ref

  return (
    <UpdateServiceWorkerContext.Provider value={{ isUpdateAvailable, triggerUpdate }}>
      {children}
    </UpdateServiceWorkerContext.Provider>
  );
};
